import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'biz-sync-files-error-table',
  templateUrl: './sync-files-error-table.component.html',
  styleUrls: ['./sync-files-error-table.component.scss']
})
export class SyncFilesErrorTableComponent implements OnInit {

  public pageSize = 5;
  public currentPage: number;
  @Input() errorData: any;
  @Input() status: string;
  @Input() showLog: boolean = false;

  constructor() { 
  }

  ngOnInit() {
  }

  ngOnChanges() {
  }

}
